import { Injectable } from "@angular/core";
import { GuessMeLogEvent } from "src/app/interfaces/log/guess-me.dto";
import { LogService } from "../log.service";

@Injectable({
  providedIn: 'root'
})
export class GuessMeLogService {
  constructor(private logService: LogService) {

  }

  logGuessMeGuestReplyDetailMakeOwnClicked(score: number): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeGuestReplyDetailMakeOwnClicked, { score })
  }
  logGuessMeGuestReplyDetailViewed(score: number): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeGuestReplyDetailViewed, { score })
  }
  logGuessMeHostQuizDetailShareKakaoClicked(replyOnThisQuiz: number): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeHostQuizDetailShareKakaoClicked, { replyOnThisQuiz })
  }
  logGuessMeHostQuizDetailShareURLClicked(replyOnThisQuiz: number): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeHostQuizDetailShareURLClicked, { replyOnThisQuiz })
  }
  logGuessMeHostQuizDetailShareWebshareClicked(replyOnThisQuiz: number): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeHostQuizDetailShareWebshareClicked, { replyOnThisQuiz })
  }
  logGuessMeHostQuizDetailViewed(replyOnThisQuiz: number): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeHostQuizDetailViewed, { replyOnThisQuiz })
  }
  logGuessMeHostReplyDetailViewed(score: number): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeHostReplyDetailViewed, { score })
  }
  logGuessMeQuizCreateAnswerSelectClicked(stage: number, questionContent: string): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeQuizCreateAnswerSelectClicked, { stage, questionContent })
  }
  logGuessMeQuizCreateChangeQuestionClicked(stage: number, questionContent: string): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeQuizCreateChangeQuestionClicked, { stage, questionContent })
  }
  logGuessMeQuizCreateNameEntryViewed(): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeQuizCreateNameEntryViewed, {})
  }
  logGuessMeQuizCreateQuestionnaireViewed(stage: number, questionContent: string): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeQuizCreateQuestionnaireViewed, { stage, questionContent })
  }
  logGuessMeQuizCreateQuizCreateSubmit(): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeQuizCreateQuizCreateSubmit, {})
  }
  logGuessMeReplyCreateAnswerSelectClicked(stage: number, questionContent: string): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeReplyCreateAnswerSelectClicked, { stage, questionContent })
  }
  logGuessMeReplyCreateNameEntryViewed(): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeReplyCreateNameEntryViewed, {})
  }
  logGuessMeReplyCreateQuestionnaireViewed(stage: number, questionContent: string): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeReplyCreateQuestionnaireViewed, { stage, questionContent })
  }
  logGuessMeReplyCreateReplyCreateSubmit(): void {
    this.logService.eventLogging(GuessMeLogEvent.guessMeReplyCreateReplyCreateSubmit, {})
  }
  logHomeGuessMeClicked(): void {
    this.logService.eventLogging(GuessMeLogEvent.homeGuessMeClicked, {})
  }
  logHomeGuessMeImpression(): void {
    this.logService.eventLogging(GuessMeLogEvent.homeGuessMeImpression, {})
  }
}